import React, { useEffect, useState } from "react";
import { Switch, Route, useHistory, Redirect } from "react-router-dom";
import RequestTypes from "./RequestTypes";
import EvidenceTypes from "./EvidenceTypes";
import { Tabs } from "components/common_components/Tabs";
import Header from "components/common_components/Header";

const options = [
    { index: 0, label: "Request Types", path: "/settings/chain-of-custody/request-types", icon: "archive" },
    { index: 1, label: "Evidence Types", path: "/settings/chain-of-custody/evidence-types", icon: "file-doc" },
];

function ChainOfCustody(props) {
    const history = useHistory();
    const [selectedOption, setSelectedOption] = useState(options[0]);

    useEffect(() => {
        const newSelectedOption = options.find((o) => history.location.pathname.startsWith(o.path));
        if (newSelectedOption) {
            setSelectedOption(newSelectedOption);
        }
    }, [history.location.pathname]);

    function handleChange(_, newIndex) {
        history.push(options.find((o) => o.index === newIndex).path);
    }

    const renderTabLabel = (label) => {
        return label;
    };
    return (
        <>
            <Header title="Chain of Custody" />
            <Tabs options={options} selectedOption={selectedOption} onChange={handleChange} renderTabLabel={renderTabLabel}>
                <Switch>
                    <Redirect exact from="/settings/chain-of-custody" to="/settings/chain-of-custody/request-types" />
                    <Route exact path="/settings/chain-of-custody/request-types" component={RequestTypes} />
                    <Route exact path="/settings/chain-of-custody/evidence-types" component={EvidenceTypes} />
                </Switch>
            </Tabs>
        </>
    );
}

export default ChainOfCustody;
